module.exports = __webpack_public_path__ + "img/logo-no-text.d9268677.svg";